'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _axiosRetry = require('axios-retry');

var _axiosRetry2 = _interopRequireDefault(_axiosRetry);

var _companies = require('./lib/companies');

var _companies2 = _interopRequireDefault(_companies);

var _licenses = require('./lib/licenses');

var _licenses2 = _interopRequireDefault(_licenses);

var _users = require('./lib/users');

var _users2 = _interopRequireDefault(_users);

var _apps = require('./lib/apps');

var _apps2 = _interopRequireDefault(_apps);

var _silentRefresh = require('./lib/silentRefresh');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('es6-promise').polyfill();
var CSRF_RANDOM = csrfRandom();
var REDIRECT_TO_LOGIN = null;
var REDIRECT_URI = null;
var Apiclient = function Apiclient(options) {

    REDIRECT_URI = options.REDIRECT_URI;
    var CLOUD_API = options.CLOUD_API;
    var HOUR_APP_BACKEND = options.HOUR_APP_BACKEND;
    var CLIENT_ID = options.CLIENT_ID;
    var BASEURL = options.baseURL;
    var VERSION = options.version ? options.version : 'v1';
    var token = options.token;
    REDIRECT_TO_LOGIN = 'https://oauth.motivate.nl/oauth2/auth?response_type=token&client_id=' + CLIENT_ID + '&redirect_uri=' + REDIRECT_URI + '&state=' + CSRF_RANDOM;

    var AxiosClient = _axios2.default.create({
        baseURL: BASEURL,
        timeout: 5000,
        headers: {
            Authorization: 'Bearer ' + token
        }
    });
    (0, _axiosRetry2.default)(AxiosClient, { retries: 5 });
    AxiosClient.interceptors.request.use(function (config) {

        return config;
    }, function (error) {
        return error;
    });
    AxiosClient.interceptors.response.use(function (response) {
        // when success from server
        if (response.status === 401) {
            window.location = REDIRECT_TO_LOGIN;
        }

        return response;
    }, function (error) {
        if (!error.response) {
            window.location = REDIRECT_TO_LOGIN;
        }
        if (error.response.status === 401) {
            window.location = REDIRECT_TO_LOGIN;
        }

        return error;
    });
    return {
        REDIRECT_URI: REDIRECT_TO_LOGIN,
        axiosWrapper: AxiosClient,
        silentRefresher: _silentRefresh.silentRefresher,
        logout: logout,
        Company: (0, _companies2.default)(BASEURL, VERSION, AxiosClient),
        Licenses: (0, _licenses2.default)(BASEURL, VERSION, AxiosClient),
        User: (0, _users2.default)(BASEURL, VERSION, AxiosClient),
        App: (0, _apps2.default)(BASEURL, VERSION, AxiosClient),
        token: token,
        CLOUD_API: CLOUD_API,
        HOUR_APP_BACKEND: HOUR_APP_BACKEND,
    };
};

exports.default = Apiclient;


var logout = function logOut() {
    localStorage.removeItem('vuex');
    localStorage.removeItem('firebaseToken');
    window.location = '/';
};
function csrfRandom() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 8; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }return text;
}